/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.0.9 PlatformEdgeGlow.gltf --transform
*/

import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei';

import PlatformEdgeGlowModel from './PlatformEdgeGlow-transformed.glb';

export default function Model(props) {
	const { nodes, materials } = useGLTF(PlatformEdgeGlowModel);
	const color = props.color;

	return (
		<group
			{...props}
			dispose={null}
			scale={100}
			rotation={[-Math.PI / 2, 0, 0]}
		>
			<mesh
				geometry={nodes.mesh0_mesh.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_1.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_2.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_3.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_4.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_5.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_6.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_7.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_8.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_9.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_10.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_11.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_12.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_13.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_14.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_15.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_16.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_17.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_18.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_19.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_20.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_21.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_22.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_23.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_24.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_25.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_26.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_27.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_28.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_29.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_30.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_31.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_32.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_33.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_34.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_35.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_36.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_37.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_38.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_39.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_40.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_41.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_42.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_43.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_44.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_45.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_46.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_47.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_48.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_49.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_50.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_51.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_52.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_53.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_54.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_55.geometry}
				material={materials['0.980392_0.713725_0.003922_0.000000_0.000000']}
			>
				<meshBasicMaterial color={color} toneMapped={false} />
			</mesh>
		</group>
	);
}

useGLTF.preload('/PlatformEdgeGlow-transformed.glb');
